import { useEffect, useState } from 'react';
import useVideoContext from './useVideoContext';
import { Logger } from '../utils';

export default function useIsLocalParticipantReconnecting() {
    const [isReconnecting, setIsReconnecting] = useState(false);
    const { room } = useVideoContext();

    useEffect(() => {
        if (room.localParticipant) {
            const handleReconnecting = (localParticipant) => {
                Logger("UI.Twilio.LocalParticipant.Reconnecting", new Date(), { participant: localParticipant });
                setIsReconnecting(true);
            };

            const handleReconnected = () => {
                Logger("UI.Twilio.LocalParticipant.Reconnected", new Date());
                setIsReconnecting(false);
            };

            room.localParticipant.on('reconnecting', handleReconnecting);
            room.localParticipant.on('reconnected', handleReconnected);
            return () => {
                room.localParticipant.off('reconnecting', handleReconnecting);
                room.localParticipant.off('reconnected', handleReconnected);
            };
        }
    }, [room]);

    return isReconnecting;
}